export default "__VITE_ASSET__DSKIKU3Y__"